import { defineFcm } from '../shared/factory';

export const FCM_CREAM_CHIP_IN_VALUES = defineFcm('cream_chip_in_values').asNumber().withDefault(undefined).toConfig();
